import React, { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";
import { X } from "lucide-react";
import PageMeta from "../components/PageMeta";

export default function Realizations() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lightbox, setLightbox] = useState(null);

    useEffect(() => {
        api.get("/realizations")
            .then((r) => setItems(r.data.items || []))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="bg-[#09090b] text-zinc-100">
            <PageMeta
                title="Nos réalisations — Sponsormania.fr | Galerie maillots financés"
                description="Galerie des maillots de clubs amateurs financés grâce au micro-sponsoring sportif Sponsormania. Football, basketball, rugby, handball — découvrez nos réalisations."
            />
            <section className="border-b border-zinc-900 px-6 lg:px-8 pt-16 pb-12">
                <div className="max-w-7xl mx-auto">
                    <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-3">
                        Galerie
                    </div>
                    <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] tracking-tighter">
                        Nos <span className="text-orange-500">réalisations</span>
                    </h1>
                    <p className="mt-4 max-w-3xl text-zinc-300">
                        Les maillots déjà livrés aux clubs partenaires. Cliquez pour agrandir.
                    </p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
                {loading ? (
                    <div className="text-zinc-500 text-center py-16">Chargement…</div>
                ) : items.length === 0 ? (
                    <div className="card-tu text-center py-20 text-zinc-500">
                        Aucune réalisation publiée pour le moment.
                    </div>
                ) : (
                    <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4" data-testid="realizations-grid">
                        {items.map((it) => (
                            <button
                                key={it.id}
                                type="button"
                                data-testid={`realization-${it.id}`}
                                onClick={() => setLightbox(it)}
                                className="block w-full break-inside-avoid border border-zinc-800 bg-zinc-950 overflow-hidden text-left hover:border-orange-500 transition-colors"
                            >
                                <div className="relative">
                                    <img
                                        src={fileUrl(it.image_path)}
                                        alt={it.title}
                                        className="w-full h-auto block"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="p-4">
                                    <div className="font-display text-xl uppercase tracking-tight">{it.title}</div>
                                    {it.description && (
                                        <p className="text-sm text-zinc-400 mt-1 line-clamp-2">{it.description}</p>
                                    )}
                                </div>
                            </button>
                        ))}
                    </div>
                )}
            </section>

            {lightbox && (
                <div
                    className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-6"
                    onClick={() => setLightbox(null)}
                    data-testid="realization-lightbox"
                >
                    <button
                        onClick={() => setLightbox(null)}
                        className="absolute top-6 right-6 text-white hover:text-orange-500"
                        aria-label="Fermer"
                    >
                        <X size={28} />
                    </button>
                    <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
                        <img
                            src={fileUrl(lightbox.image_path)}
                            alt={lightbox.title}
                            className="w-full h-auto max-h-[80vh] object-contain border border-zinc-800"
                        />
                        <div className="mt-4 text-center">
                            <h3 className="font-display text-2xl uppercase tracking-tight">{lightbox.title}</h3>
                            {lightbox.description && <p className="text-zinc-400 text-sm mt-2">{lightbox.description}</p>}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
